<template>
  <div class="grid">
    <template v-for="key in orderedKeys">
      <div :key="`${key}-label`" :for="`${formId}-${key}`">
        {{ labels[key].label }}
      </div>
      <DetailProxy
        v-if="value[key]"
        :id="key"
        :key="key"
        :htmlId="`${formId}-${key}`"
        :value="value[key]"
        :meta="meta"
        @input="input(key, $event)"
        @labelOptions="labelOptions(key, $event)"
      ></DetailProxy>
      <div
        v-else
        :key="`${formId}-${key}`"
        class="empty-value"
      >
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import DetailProxy from './property-detail-proxy'
import { uuid } from 'vue-uuid'

export default {
    name: 'PropertyDetailTable',
    components: {
        DetailProxy,
    },
    props: {
        value: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        propertyKeys: {
            required: false,
            type: Array,
            default: _ => [],
        },
        customProperties: {
            required: false,
            type: Boolean,
            default: _ => false,
        },
        meta: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
    },
    data() {
        return {
            customPropertyKeys: [],
            labelsOptions: {},
        }
    },
    computed: {
        keys() {
            return _.union(_.union(_.keys(this.value), this.propertyKeys), this.customPropertyKeys)
        },
        orderedKeys() {
            return _.sortBy(this.keys, [
                k => _.toNumber(_.get(this.$store.getters.propertyTypeByKey(k), 'settings.order', '0')),
                k => k,
            ])
        },
        labels() {
            return _.chain(this.keys)
                .mapKeys(k => k)
                .mapValues(k => {
                    return {
                        label: _.get(this.$store.getters.propertyTypeByKey(k), 'name'),
                        options: _.get(this.labelsOptions, k, []),
                    }
                })
                .value()
        },
        formId() {
            return uuid.v4()
        },
    },
    methods: {
        input(key, e) {
            Vue.set(this.value, key, e) // TODO zkontrolovat reaktivitu protoze tohle naprimo mutuje value objekt
            this.$emit('input', this.value) // TODO tohle by melo fungovat ale nefunguje
        },
        labelOptions(key, e) {
            Vue.set(this.labelsOptions, key, e)
        },
        addCustomProperty(e) {
            this.customPropertyKeys.push(e.target.value)
        },
    },
}
</script>

<style scoped lang="scss">
@media (min-width: 1200px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(0px, auto);
    grid-template-columns: 1fr 3fr 1fr 3fr 1fr 3fr;
    grid-gap: 0;
    border-right: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    & > * {
        border-top: 1px solid lightgray;
        border-left: 1px solid lightgray;
        padding: 5px;
        line-height: 120%;
        &:nth-child(odd) {
            font-size: 0.8rem;
            background-color: rgba(0,0,0,0.05);
        }
    }
  }
}
.empty-value {
            background: repeating-linear-gradient(
                135deg,
                transparent 0,
                transparent 7px,
                rgba(0,0,0,0.03) 7px,
                rgba(0,0,0,0.03) 14px
            );
            font-style: italic;
            color: lightgrey;
        }
</style>

